// namespace
window.Components = window.Components || {};

(function($) {

  'use strict';

  function videoHtml() {

    var self = this,
        $cache = {};

    function openFilter() {
        var tl = new TimelineMax({paused: true, onStart: function() {
            $cache.listHide.addClass('is-active');
          }});

        var h = $cache.listHide.outerHeight();

        tl.to($cache.listWrapper, 0.5, {height: h, force3D: true, ease: Expo.easeOut}, 0);
        //tl.fromTo($cache.listWrapper, 0.5, {height: "0"}, {height: "100%", force3D: true, ease: Power3.easeOut}, 0);
        tl.fromTo($cache.listHide, 0.4, {opacity: 0}, {opacity: 1, ease: Quad.easeInOut}, 0.5);
        //tl.fromTo($cache.fixedNavMbContent, 0.6, {x: 200}, {x: 0, force3D: true, ease: Power2.easeOut}, 0.2);

        tl.play();
    }
    
    /**
     * Init Cache
     */
    function initCache(target) {
        $cache.html = $('html');
        $cache.body = $cache.html.find('body');
        $cache.main = $cache.body.find('.main');

        $cache.play = $cache.videoHtml.find('.play');
        $cache.close = $cache.videoHtml.find('.close');

        $cache.modal = $cache.videoHtml.find('.modal-video');
        $cache.modalBg = $cache.modal.find('.modal-bg');
        $cache.vidWrapper = $cache.modal.find('.video-wrapper');

        $cache.video = $cache.modal.find('video');
        $cache.itemContainer = $cache.videoHtml.parents('.item');
        $cache.lengthValue = $cache.itemContainer.find('.length-value');
    }

    function toggleModal() {
      if(!$cache.isOpen) {
        openModal();
      }
      else {
        closeModal();
      }
    }

    function openModal() {
      if($cache.isOpen) return;
      
      var tl = new TimelineMax({paused: true, onStart: function() {
        $cache.isOpen = true;
        $cache.modal.addClass('is-active');
        $cache.html.addClass('scroll-disabled');
      }});

      tl.fromTo($cache.modalBg, 0.5, {height: 0}, {height: "100%", ease: Quad.easeOut}, 0);
      tl.fromTo($cache.vidWrapper, 0.3, {opacity: 0}, {opacity: 1, ease: Quad.easeOut}, 0.5);

      tl.play();
    }

    function closeModal() {
      var tl = new TimelineMax({paused: true, onComplete: function() {
        $cache.isOpen = false;
        $cache.modal.removeClass('is-active');
        $cache.html.removeClass('scroll-disabled');
      }});

      tl.fromTo($cache.vidWrapper, 0.3, {opacity: 1}, {opacity: 0, ease: Quad.easeOut}, 0);
      tl.fromTo($cache.modalBg, 0.5, {height: "100%"}, {height: 0, ease: Quad.easeOut}, 0.3);

      tl.play();
    }

    function initVidLength() {
      var time = $cache.video[0].duration;

      var min = Math.floor(time/60);
      var seconds = Math.floor(time - min * 60);

      if(seconds < 10) seconds = '0' + seconds;

      $cache.lengthValue.text(min + ':' + seconds);
      //console.log($cache.lengthValue);
    }

    /**
     * Register Events
     */
    function registerEvents() {

        $cache.play.on('click', function() {
            toggleModal();
        })

        $cache.close.on('click', function() {
            toggleModal();
        })

        $cache.modalBg.on('click', function() {
            closeModal();
        })

        $cache.video.on('loadedmetadata', function() {
          console.log('on load');
          initVidLength();
        })
    }


    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(target) {    
        $cache.videoHtml = target;  
        initCache(target);
        registerEvents();
        //initVidLength();

        $cache.isOpen = false;

      //initSliders();
    };

    self.initialize.apply(self, arguments);
    return self;
  }
  
  window.Components.videoHtml = videoHtml;
  
}(jQuery));
